// frontend/src/SearchPage.js
import Sidebar from '../Sidebar/Sidebardigital';
import React, { useState } from 'react';
import '../Farmer/search.css';

const SearchPage = () => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  const handleSearch = async () => {
    
      let response = await fetch(`https://gatisheelback.azurewebsites.net/search?query=${query}`);
      if (!response.ok) {
        throw new Error('Failed to fetch results');
      }
      const data = await response.json();
      setResults(data); 
    
  };

  return (
<>
<div className="row">
        <div className="col-2 custom-display">
          <Sidebar />
        </div>
        <div className="col-8 custom-width">
      <br></br><h1>Search Page</h1><br></br>
      <input type="text" value={query} onChange={(e) => setQuery(e.target.value)} />
      <button onClick={handleSearch}>Search</button><br></br>
      <br></br><br></br><br></br>
      <div className="table-container">
      <table className='Table'>
  <thead>
    <tr>
      <th style={{ border: '1px solid black', padding: '8px' }}>Name</th>
      <th style={{ border: '1px solid black', padding: '8px' }}>Mobile</th>
      <th style={{ border: '1px solid black', padding: '8px' }}>District</th>
      <th style={{ border: '1px solid black', padding: '8px' }}>Owner</th>
      <th style={{ border: '1px solid black', padding: '8px' }}>Village</th>
      <th style={{ border: '1px solid black', padding: '8px' }}>Interest</th>
      <th style={{ border: '1px solid black', padding: '8px' }}>Discussion</th>
    </tr>
  </thead>
  <tbody>
    {results.map((farmer, index) => (
      <tr key={index}>
        <td style={{ border: '1px solid black', padding: '8px' }}>{farmer.name}</td>
        <td style={{ border: '1px solid black', padding: '8px' }}>{farmer.mobile}</td>
        <td style={{ border: '1px solid black', padding: '8px' }}>{farmer.district}</td>
        <td style={{ border: '1px solid black', padding: '8px' }}>{farmer.owner}</td>
        <td style={{ border: '1px solid black', padding: '8px' }}>{farmer.village}</td>
        <td style={{ border: '1px solid black', padding: '8px' }}>{farmer.interest}</td>
        <td style={{ border: '1px solid black', padding: '8px' }}>{farmer.discuss}</td>
      </tr>
    ))}
  </tbody>
</table>
</div>
<br></br><br></br><br></br><br></br>
      {/* <ul>
        {results.map((farmer, index) => (
          <li key={index}>{farmer.name} - {farmer.mobile} - {farmer.district}<br></br><br></br></li>
        ))}
      </ul> */}
          </div>
        <div className="col-2 custom-display">
          <Sidebar />
        </div>
      </div>
    </>
  );
        }
export default SearchPage;
